import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  /* 폰트는 index.html <head>에서 로드됩니다 */

  *, *::before, *::after {
    box-sizing: border-box;
  }

  body {
    margin: 0;
    font-family: "Satoshi", "Pretendard", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
  }
`;
